'use strict';

module.exports = require('./src/js/main');



//////////////////
// WEBPACK FOOTER
// G:/gitlab-runner/builds/fyb93P4s/0/kpmg/novacci.kpmg.cz/~/perfect-scrollbar/index.js
// module id = 95
// module chunks = 0